import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkle } from "@phosphor-icons/react";
import ProntoLogo from "@/components/ProntoLogo";

const POSTS = [
  {
    slug: "mandati-esclusiva-tecniche",
    title: "Acquisire mandati in esclusiva: 5 tecniche che funzionano davvero nel 2026",
    excerpt:
      "Lo script di apertura, la valutazione che convince, il piano marketing che fa la differenza. Niente teoria — solo cose testate sul campo.",
    date: "8 maggio 2026",
    readingTime: "9 min",
    tag: "Acquisizione",
  },
  {
    slug: "home-staging-low-cost",
    title: "Home staging low cost: 7 cose da fare nelle 2 ore prima di una visita",
    excerpt:
      "Senza spendere un euro in mobili. Trucchi pratici di pulizia, profumazione e ordine che alzano del 5–10% le offerte.",
    date: "7 maggio 2026",
    readingTime: "7 min",
    tag: "Visite",
  },
  {
    slug: "idealista-vs-immobiliare-it",
    title: "Idealista vs Immobiliare.it: dove pubblicare per primo e come ottimizzare il ranking",
    excerpt:
      "I due portali pesano in modo diverso ogni elemento dell'annuncio. La sequenza giusta di pubblicazione fa risparmiare giorni di visibilità.",
    date: "6 maggio 2026",
    readingTime: "8 min",
    tag: "Portali",
  },
  {
    slug: "foto-immobili-smartphone",
    title: "Come fare foto immobili professionali con lo smartphone (senza essere fotografo)",
    excerpt:
      "Le foto sono la prima cosa che vede chi cerca casa. Ti spieghiamo i 7 trucchi che fanno la differenza, e come Pronto le rifinisce in pochi secondi.",
    date: "5 maggio 2026",
    readingTime: "6 min",
    tag: "Guida pratica",
  },
  {
    slug: "annuncio-immobiliare-vendita",
    title: "Come scrivere un annuncio immobiliare che vende davvero (esempi inclusi)",
    excerpt:
      "Titolo, descrizione, parole chiave, errori da evitare. Una guida pratica con esempi reali per agenti italiani.",
    date: "3 maggio 2026",
    readingTime: "8 min",
    tag: "Marketing",
  },
  {
    slug: "valutazione-immobile-veloce",
    title: "Come fare una valutazione immobiliare veloce al cliente (in 5 minuti)",
    excerpt:
      "OMI, comparazione di mercato, e i 3 numeri che ogni agente deve avere a portata di mano per non perdere un acquisizione.",
    date: "1 maggio 2026",
    readingTime: "5 min",
    tag: "Acquisizione",
  },
];

export default function Blog() {
  return (
    <div className="min-h-screen bg-[#FAFAF7]">
      <header className="border-b border-[#EDEAE2] bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="blog-logo-home">
            <ProntoLogo size={28} />
          </Link>
          <Link to="/register" className="btn-primary text-[13px]" data-testid="blog-cta-register">
            Provala gratuitamente <ArrowRight size={14} weight="bold" />
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-10 sm:py-16">
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-[#7C8B6E]/25 mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-[#7C8B6E]" />
            <span className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#5A6A4D]">
              Pronto Magazine
            </span>
          </span>
          <h1 className="font-editorial text-[32px] sm:text-5xl tracking-tight leading-[1.1] text-[#1C1C1A]">
            Guide pratiche<br />
            <span className="italic-accent text-[#7C8B6E]">per chi vende case.</span>
          </h1>
          <p className="mt-4 text-[15px] sm:text-[17px] text-[#6B6A65] max-w-xl mx-auto leading-relaxed">
            Trucchi del mestiere, esempi reali, niente fuffa. Scritto per agenti italiani che hanno
            poco tempo e tante visite.
          </p>
        </div>

        <div className="space-y-4">
          {POSTS.map((p) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              className="block bg-white border border-[#E5E7E0] rounded-xl p-6 sm:p-7 hover:border-[#7C8B6E]/40 hover:shadow-sm transition-all"
              data-testid={`blog-post-${p.slug}`}
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="inline-block px-2 py-0.5 rounded-full bg-[#F1F4ED] text-[10px] uppercase tracking-[0.18em] font-semibold text-[#5A6A4D]">
                  {p.tag}
                </span>
                <span className="text-[11px] text-[#9A968B]">{p.date}</span>
                <span className="w-1 h-1 rounded-full bg-[#E5E7E0]" />
                <span className="text-[11px] text-[#9A968B]">{p.readingTime}</span>
              </div>
              <h2 className="font-editorial text-[20px] sm:text-[24px] leading-tight text-[#1C1C1A] mb-2">
                {p.title}
              </h2>
              <p className="text-[14px] text-[#6B6A65] leading-relaxed">{p.excerpt}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-[12px] uppercase tracking-[0.18em] text-[#7C8B6E] font-semibold">
                Leggi <ArrowRight size={12} weight="bold" />
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 bg-white border border-[#E5E7E0] rounded-xl p-6 sm:p-8 text-center">
          <Sparkle size={24} weight="fill" className="mx-auto text-amber-600 mb-3" />
          <h3 className="font-editorial text-[20px] sm:text-2xl text-[#1C1C1A] mb-2 leading-tight">
            Vuoi provare quello che leggi?
          </h3>
          <p className="text-[14px] text-[#6B6A65] mb-5 max-w-md mx-auto">
            Pronto è l'app che ti aiuta a fare foto, annunci e brochure in pochi secondi. Gratis per
            30 giorni, senza carta.
          </p>
          <Link to="/register" className="btn-primary inline-flex" data-testid="blog-bottom-cta">
            Iscrizione gratuita <ArrowRight size={14} weight="bold" />
          </Link>
        </div>
      </main>

      <footer className="border-t border-[#EDEAE2] bg-white py-8 mt-16">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center text-[12px] text-[#9A968B]">
          <Link to="/" className="hover:text-[#1C1C1A] transition-colors">Pronto · l'app dell'agente immobiliare</Link>
        </div>
      </footer>
    </div>
  );
}
